console.log('Yardsale')

const epigraph = document.getElementById("epigraphConfiguratorLite");
if (epigraph) {
  window.epigraph = epigraph
  window.addEventListener(
    "core:ready",
    (event) => {
      setTimeout(() => {
        if (epigraph.hasAttribute("data-class")) {
          // window.epigraph.api.makeProductClassIdActive("rightPole");
        }

        if (epigraph.hasAttribute("data-variant")) {
          // window.epigraph.api.makeProductClassIdActive(epigraph.getAttribute("data-class"));
          window.epigraph.api.switchVariantForProductClass("rightHandle", "sand")
          window.epigraph.api.switchVariantForProductClass("leftHandle", "sand")
          window.epigraph.api.switchVariantForProductClass("rightStrap", "sand")
          window.epigraph.api.switchVariantForProductClass("leftStrap", "sand")
          window.epigraph.api.switchVariantForProductClass("rightBasket", "sand")
          window.epigraph.api.switchVariantForProductClass("leftBasket", "sand")
          window.epigraph.api.switchVariantForProductClass("rightPole", "sand")
          window.epigraph.api.switchVariantForProductClass("leftPole", "sand")
        }
      }, 1000);
      // console.log(epigraph.getAttribute("data-class"))
      
    }
  );
}

const sides = ['left', 'right'];
const products = ['pole', 'handle', 'strap', 'basket'];
const productDisplayName = {
  'pole': 'Pole',
  'handle': 'Handle',
  'strap': 'Strap',
  'basket': 'Basket',
};
const productHandleName = {
  'pole': 'pole',
  'handle': 'yardsale-p1-handle',
  'strap': 'yardsale-p1-straps',
  'basket': 'yardsale-p1-basket',
};

/// The key to use to look up the value in the form data
const getFormDataPropName = (side, product) => `items[${side}-${productHandleName[product]}][color]`;
/// The key to use for the custom prop. This will be visible to the customer in the checkout/cart
const getDisplayName = (side, product) => `items[Pole][properties][${productDisplayName[product]}(${side[0].toUpperCase()})]`;

// SKUs end with a suffix that denotes the color
const skuColors = {
  "PowderDay": "S",
  "Sunlight": "Y",
  "SkiPatrol": "R",
  "TreeRun": "G",
};
const productSkus = {
  "handle": "P-1001",
  "basket": "P-1007",
  "strap": "P-1008",
};
const poleSkus = {
  "110cm": "P-1002",
  "115cm": "P-1003",
  "120cm": "P-1004",
  "125cm": "P-1005",
  "130cm": "P-1006",
};
const getSku = (side, product, poleSize, color) => {
  const skuColor = skuColors[color];
  if (product === 'pole') {
      return `${poleSkus[poleSize]}-${skuColor}`;
  } else {
      return `${productSkus[product]}-${skuColor}`;
  }
};

function builderParams(form, seperator='%26') {
  const formData = new FormData(form);
  const formProps = Object.fromEntries(formData);
  // Map the formProps to a single product with properties that describe every option
  // Check taxes are new line item
  const param = (key, value) => `${key}=${value}`;

  const poleSize = formProps['left-pole']; // left-pole and right-pole should have same value. We should remove the two inputs for each side
  const formPropsStr = Object.entries(formProps).map(([k, v]) => `${k}:${v}`).join(",");
  const params = [
    // This is just the single variant for the P1 Pole product
    param('items[Pole][id]', '47651031286071'),
    // Send all form data in case any of the mapping goes wrong - then we can at least see everything that was selected
    param('items[Pole][properties][_formData]', encodeURI(formPropsStr)),
    param('items[Pole][properties][Size]', poleSize),
  ];

  const skus = [];
  // We are representing the selected options inside the custom properties for the single pole line item
  for (side of sides) {
    for (product of products) {
      // Add the colors of each product as a custom property to the line item
      const propName = getFormDataPropName(side, product);
      const displayName = getDisplayName(side, product);
      const color = formProps[propName];
      params.push(param(displayName, color));

      // And calculate the SKU of the product
      skus.push(getSku(side, product, poleSize, color));
    }
  }
  // Then add the list of real SKUs to the product properties for our automix integration
  params.push(param('items[Pole][properties][_skus]', skus.join(',')));
  
  if (formProps["properties[addGoPro]"] === "true") {
    params.push(param('items[GoProMount][id]', '48301721452855'));
  }

  return params.join(seperator);
}

function gcBuilderParams(form, seperator='%26') {
  const formData = new FormData(form);
  const formProps = Object.fromEntries(formData);
  const price = formProps["gift-card-price"];
  const variantId = {
    '50': '47686835831095',
    '75': '47686835929399',
    '100': '47686835962167',
    '139': '47686835994935',
    '159': '47686836027703'
  }[price];
  console.log(formProps);
  // Map the formProps to a single product with properties that describe every option
  // Check taxes are new line item
  const param = (key, value) => `${key}=${value}`;

  const formPropsStr = Object.entries(formProps).map(([k, v]) => `${k}:${v}`).join(",");
  const params = [
    // This is just the single variant for the P1 Pole product
    param('items[GiftCard][id]', variantId),
    // Send all form data in case any of the mapping goes wrong - then we can at least see everything that was selected
    param('items[GiftCard][properties][_formData]', encodeURI(formPropsStr)),
  ];
  return params.join(seperator);
}

const builder = document.getElementById("pole-builder");
if (builder) {
  builder.addEventListener("submit", e => {
    e.preventDefault()
    const params = builderParams(e.target);

    window.location = `/cart/clear?return_to=${`/cart/add?${params}%26return_to=checkout`}`
  })

  const add = document.getElementById("add-to-cart");
  if (add) {
    add.addEventListener("click", e => {
      e.preventDefault()
      window.location = `/cart/add?${builderParams(builder, '&')}`
    })
  }
}

const gcBuilder = document.getElementById("gc-builder");
if (gcBuilder) {
  const gcAdd = document.getElementById("gc-add-to-cart");
  if (gcAdd) {
    gcAdd.addEventListener("click", e => {
      e.preventDefault()
      window.location = `/cart/add?${gcBuilderParams(gcBuilder, '&')}`
    })
  }
}

const header = document.getElementById("header");
if (header) {
  if (header.hasAttribute('data-header')) {
    const attributes = JSON.parse(header.getAttribute('data-header'))

    window.addEventListener('scroll', (e) => {
      if (header.hasAttribute('style') && window.scrollY > 0) {
        header.removeAttribute('style')
      } else if (!header.hasAttribute('style') && window.scrollY <= 0) {
        header.style.color = `rgb(${attributes.foreground})`
        header.style.background = `linear-gradient(rgba(${attributes.background}, 0.666), rgba(${attributes.background}, 0))`
      }
    })
  }
}

const onscrolls = document.querySelectorAll("[data-onscroll]");
if (onscrolls) {
  const observer = new IntersectionObserver((elements, observer) => {
    elements.forEach((element, index) => {
      if (element.isIntersecting) {
        !element.target.classList.contains('visible') && element.target.classList.add('visible')
      } else {
        element.target.classList.contains('visible') && element.target.classList.remove('visible')
      }
    });
  }, {
    rootMargin: '0px 0px 0px 0px',
  });
  onscrolls.forEach((element) => observer.observe(element));
}

const variants = {
  'Powder Day': 'sand',
  'Sunlight': 'yellow',
  'Ski Patrol': 'red',
  'Tree Run': 'green',
}

const classes = document.querySelectorAll("[data-3d-class]");
let timeoutMoveToBothView;
if (classes) {
  window.addEventListener(
    "core:ready",
    () => {
      window.epigraph.api.moveCameraToCameraViewById('pole-both-mobile');
    }
  )
  classes.forEach(c => {
    c.addEventListener("click", () => {
      if (window.epigraph) {
        console.log("Epigraph value clicked", variants[c.getAttribute("data-value")])
        // In 5s, move back to the double pole view
        clearTimeout(timeoutMoveToBothView);
        timeoutMoveToBothView = setTimeout(() => { window.epigraph.api.moveCameraToCameraViewById('pole-both-mobile'); }, 5000)
        if (c.getAttribute("data-3d-class").startsWith('both')) {
          window.epigraph.api.moveCameraToCameraViewById(c.getAttribute("data-3d-class").replace('both', '').toLowerCase() + '-both-mobile')
          // window.epigraph.api.makeProductClassIdActive(c.getAttribute("data-3d-class").replace('both', 'left'));

          if (c.hasAttribute("data-value") && variants[c.getAttribute("data-value")]) {
            window.epigraph.api.switchVariantForProductClass(c.getAttribute("data-3d-class").replace('both', 'left'), variants[c.getAttribute("data-value")])
            window.epigraph.api.switchVariantForProductClass(c.getAttribute("data-3d-class").replace('both', 'right'), variants[c.getAttribute("data-value")])
          }
        } else if(c.getAttribute("data-3d-class") === 'goProMount') {
          window.epigraph.api.makeProductClassIdActive(c.getAttribute("data-3d-class"));
          console.log(window.epigraph.api.getActiveProductClass().activeProduct.id)
          window.epigraph.api.makeProductIdActiveInCurrentClass(window.epigraph.api.getActiveProductClass().activeProduct.id === 'goPro' ? 'null-product' : 'goPro')
        } else {
          window.epigraph.api.makeProductClassIdActive(c.getAttribute("data-3d-class"));
          if (c.hasAttribute("data-value") && variants[c.getAttribute("data-value")]) {
            window.epigraph.api.switchVariantForProductClass(c.getAttribute("data-3d-class"), variants[c.getAttribute("data-value")])
          }
        }
      }
    })
  })
}

const allvalues = document.querySelectorAll("[data-all-values]");
if (allvalues) {
  allvalues.forEach(a => {
    a.addEventListener("click", () => {
      const value = a.getAttribute("data-all-values");
      const inputs = document.querySelectorAll(`[data-value="${value}"]`);
      console.log(`Clicking ${inputs.length} other elements that have value ${value}`);
      inputs.forEach(input => input.click());
      window.epigraph.api.moveCameraToCameraViewById('pole-both-mobile');
      
      // Experimenting to try to fix instagram browser...
      /*
      for (let inputIdx = 0; inputIdx < inputs.length; inputIdx++) {
        let input = inputs[inputIdx];
        setTimeout(() => input.click(), inputIdx*5);
      }
      setTimeout(() => window.epigraph.api.moveCameraToCameraViewById('pole-both-mobile'), inputs.length * 5 + 10);
      */
    })
  })
}

const floats = document.querySelectorAll("[data-float-right]");
if (floats?.length) {
  floats[0].classList.add("float--active")
  floats.forEach(float => {
    float.addEventListener("mouseenter", () => {
      floats.forEach(f => {
        f.classList.remove("float--active")
      })
      float.classList.add("float--active")
    })
  })
}


// class DeferredMedia extends HTMLElement {
//   constructor() {
//     super();
//     // const poster = this.querySelector('[id^="Deferred-Poster-"]');
//     // if (!poster) {
//     //   // this.loadContent.bind(this)();
//     //   return;
//     // };
//     // poster.addEventListener('click', this.loadContent.bind(this));
//     this.loadContent.bind(this)()
//   }

//   loadContent(focus = true) {
//     window.pauseAllMedia();
//     if (!this.getAttribute('loaded')) {
//       const content = document.createElement('div');
//       content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

//       this.setAttribute('loaded', true);
//       const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
//       if (focus) deferredElement.focus();
//       if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
//         // force autoplay for safari
//         deferredElement.play();
//       }
//     }
//   }
// }

// customElements.define('deferred-media', DeferredMedia);

// function pauseAllMedia() {
//   document.querySelectorAll('.js-youtube').forEach((video) => {
//     video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
//   });
//   document.querySelectorAll('.js-vimeo').forEach((video) => {
//     video.contentWindow.postMessage('{"method":"pause"}', '*');
//   });
//   document.querySelectorAll('video').forEach((video) => video.pause());
//   document.querySelectorAll('product-model').forEach((model) => {
//     if (model.modelViewerUI) model.modelViewerUI.pause();
//   });
// }

// function fetchConfig(type = 'json') {
//   return {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
//   };
// }